import React from 'react'
import PropTypes from 'prop-types'

import { BRAND_PREFERENCE, TLM_FILTER } from '../../../constants/commons'
import TopicHelpers from '../../../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../../../classes/TopicPlanFilterHelpers'

class BrandFilterComponent extends React.Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    module: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      brandFilter: this.props.selectedPlanFilters.tlmFilters || []
    }
  }

  componentDidUpdate (previousProps) {
    if (previousProps.selectedPlanFilters !== this.props.selectedPlanFilters) {
      this.setState({ brandFilter: this.props.selectedPlanFilters.tlmFilters || []})
    }
  }

  render () {
    return (
      <>
        <ul className="checkList brandFilter">
          <li><h4>Brand Filters (OR)</h4></li>
          {this.li('Airline')}
          {this.li('Appliances')}
          {this.li('Automotive')}
          {this.li('Baby & Kids')}
          {this.li('CPG - All')}
          {this.li('CPG - Alcohol')}
          {this.li('CPG - Beauty')}
          {this.li('CPG - Beverage')}
          {this.li('CPG - Candy & Gum')}
          {this.li('CPG - Food')}
          {this.li('CPG - Home & Laundry')}
          {this.li('CPG - Personal Care')}
          {this.li('CPG - Pet Care')}
          {this.li('Entertainment')}
          {this.li('Finance')}
          {this.li('Fitness')}
          {this.li('Gaming')}
          {this.li('Hotel')}
          {this.li('Insurance')}
          {this.li('Media & News')}
          {this.li('Pharmaceuticals')}
          {this.li('Podcasts')}
          {this.li('QSR')}
          {this.li('Real Estate')}
          {this.li('Restaurant')}
          {this.li('Retail')}
          {this.li('Services')}
          {this.li('Technology')}
          {this.li('Telecommunication')}
          {this.li('Travel')}
        </ul>
      </>
    )
  }

  li = (filterText) => {
    const brandFilter = TopicPlanFilterHelpers.tlmFilter(filterText)
    const currentValue = this.state.brandFilter.find(f => TopicHelpers.equals(f, brandFilter))
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${filterText}`}
          checked={value}
          onChange={this.applyBrandFilter.bind(this, filterText)} />
        <span></span>
        <label htmlFor={`${filterText}`}>{filterText}</label>
      </li>
    )
  }

  /** Apply one of the brand and update the table filtering */
  applyBrandFilter = (filter) => {
    let filters = null

    if (filter !== 'None') {
      filters = TopicPlanFilterHelpers.tlmFilter(filter)
    }

    this.props.setFilters(filters, TLM_FILTER, BRAND_PREFERENCE)
  }
}

export default BrandFilterComponent